import script from "./ApplyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyPage.vue?vue&type=script&setup=true&lang=js"

import "./ApplyPage.vue?vue&type=style&index=0&id=164196b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164196b5"]])

export default __exports__